import { createFileRoute } from "@tanstack/react-router";

// The parent ask.tsx route handles the empty state when no threadId is present.
// This file only exists so /ask cleanly matches the parent layout.
export const Route = createFileRoute("/_authenticated/ask/")({
  component: () => null,
});
